import * as React from 'react';
import { type QuerySuggestion } from '@/types';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Button } from '../atoms/button';

export type QuerySuggestionsListProps = {
  suggestions: QuerySuggestion[];
  onEditQuerySuggestion: (querySuggestion: QuerySuggestion) => void;
};

export default function QuerySuggestionsList(props: QuerySuggestionsListProps) {
  const suggestions = props.suggestions || [];

  return (<div className="mt-4">
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Suggestion</TableHead>
          <TableHead className="w-[150px]">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {suggestions.map((suggestion) => (
          <TableRow key={suggestion.uid}>
            <TableCell>{suggestion.suggestion}</TableCell>
            <TableCell>
              <Button onClick={() => props.onEditQuerySuggestion(suggestion)}>Edit</Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>);
}